// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* A message after a change, e.g. an instrument removed (InstrumentDetails) */
.trades-notice {
  max-width: calc(90% - 60px);
  box-sizing: border-box;
  margin: 16px auto 20px;
  padding: 10px 14px;
  background: var(--color-bg-sub);
  border: 1px solid var(--color-border);
  border-left: 3px solid var(--color-blue);
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text);
}

/* The instrument list as wide as the backtest's cards above it and the
   instrument page's (BacktestOverview.css): its cards have 10px margins */
.portfolio-instruments {
  max-width: calc(90% - 40px);
  margin: 0 auto;
  padding-bottom: 20px;
  font-size: 12px;  /* like the backtest's tables; the list set none (16px) */
}

.portfolio-instruments .instrument-list-header th {
  font-size: 11px;
  letter-spacing: 0.04em;
}
`, "",{"version":3,"sources":["webpack://./src/dashboard/pages/Trades.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;0EAC0E;AAC1E;EACE,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe,GAAG,yDAAyD;AAC7E;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB","sourcesContent":["/* A message after a change, e.g. an instrument removed (InstrumentDetails) */\n.trades-notice {\n  max-width: calc(90% - 60px);\n  box-sizing: border-box;\n  margin: 16px auto 20px;\n  padding: 10px 14px;\n  background: var(--color-bg-sub);\n  border: 1px solid var(--color-border);\n  border-left: 3px solid var(--color-blue);\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text);\n}\n\n/* The instrument list as wide as the backtest's cards above it and the\n   instrument page's (BacktestOverview.css): its cards have 10px margins */\n.portfolio-instruments {\n  max-width: calc(90% - 40px);\n  margin: 0 auto;\n  padding-bottom: 20px;\n  font-size: 12px;  /* like the backtest's tables; the list set none (16px) */\n}\n\n.portfolio-instruments .instrument-list-header th {\n  font-size: 11px;\n  letter-spacing: 0.04em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
